module.exports = __webpack_public_path__ + "img/banerd.bb92c5a6.jpg";